var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{style:(_vm.params.props.style),attrs:{"icon":_vm.params.props.icon},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.params.props.text))])}
var staticRenderFns = []

export { render, staticRenderFns }